import { render, staticRenderFns } from "./HostedPaymentConnect.vue?vue&type=template&id=3c67d20a&scoped=true&"
import script from "./HostedPaymentConnect.vue?vue&type=script&lang=ts&"
export * from "./HostedPaymentConnect.vue?vue&type=script&lang=ts&"
import style0 from "./HostedPaymentConnect.vue?vue&type=style&index=0&id=3c67d20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c67d20a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSimpleTable,VTextField})
